export default [
	{
		path: '/xinyong/check',
		name: 'xinyongCheck',
		component: () => import('@/views/xinyong/check.vue'),
		meta:{ title:'血压校准' }
	},
    {
		path: '/xinyong/result',
		name: 'xinyongResult',
		component: () => import('@/views/xinyong/result.vue'),
		meta:{ title:'血压校准' }
	}
]